import { useState } from 'react';
import { useApp } from '../../context/AppContext';

function Step3() {
  const { state, dispatch } = useApp();
  const { appData } = state;
  const [loaderColor, setLoaderColor] = useState(appData.loaderColor || '#3B82F6');

  const handleNext = () => {
    dispatch({
      type: 'UPDATE_APP_DATA',
      payload: { loaderColor }
    });
    dispatch({ type: 'UPDATE_PRICE', payload: { loader: state.pricingConfig?.loader || 0 } }); // Preço para personalização do loader
    dispatch({ type: 'NEXT_STEP' });
  };

  const handleBack = () => {
    dispatch({ type: 'PREV_STEP' });
  };

  return (
    <div className="bg-white p-8 rounded-2xl shadow-xl">
      <h2 className="text-3xl font-bold mb-8 text-gray-900">Cor do Loader</h2>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-900 mb-2">
            Selecione a cor do loader
          </label>
          <div className="flex items-center">
            <input
              type="color"
              value={loaderColor}
              onChange={(e) => setLoaderColor(e.target.value)}
              className="h-12 w-12 rounded-xl border border-gray-200 cursor-pointer shadow-sm"
            />
            <span className="ml-3 text-lg font-medium text-gray-900">{loaderColor}</span>
          </div>
        </div>

        <div className="mt-6">
          <label className="block text-sm font-medium text-gray-900 mb-3">
            Preview do loader
          </label>
          <div className="flex justify-center items-center h-48 border border-gray-200 rounded-xl bg-gray-50 shadow-inner">
            <div
              className="w-16 h-16 rounded-full animate-spin border-4 border-t-transparent"
              style={{
                borderRightColor: loaderColor,
                borderBottomColor: loaderColor,
                borderLeftColor: loaderColor,
              }}
            ></div>
          </div>
        </div>
      </div>

      <div className="mt-10 flex justify-between">
        <button
          onClick={handleBack}
          className="bg-gray-100 text-gray-900 px-8 py-3 rounded-xl hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-gray-500 font-medium transition-all duration-200"
        >
          Voltar
        </button>
        <button
          onClick={handleNext}
          className="bg-gray-900 text-white px-8 py-3 rounded-xl hover:bg-black focus:outline-none focus:ring-2 focus:ring-gray-500 font-medium shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 transition-all duration-200"
        >
          Próximo
        </button>
      </div>
    </div>
  );
}

export default Step3;
